import React from "react";
import { NavLink } from "react-router-dom";

export interface ServiceItemProps {
  name: string;
  icon: React.ReactNode;
  to: string;
}

export const ServiceItem = ({ name, icon, to }: ServiceItemProps) => (
  <NavLink to={to} className="block">
    <div className="flex items-center gap-3 py-3 px-4 hover:bg-accent cursor-pointer transition-colors">
      <div className="flex items-center justify-center">{icon}</div>
      <div className="font-medium">{name}</div>
    </div>
  </NavLink>
);
